// extracted by mini-css-extract-plugin
export default {"addForm":"addForm_addForm__LEarI","formControl":"addForm_formControl__zjbts","list":"addForm_list__mZexz","btnWrpper":"addForm_btnWrpper__6+Eoo"};